<template>
  <div class="voucherDetails">
    <el-form ref="form">
      <div class="voucherTit">{{form.serviceName}}</div>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>体验券模板</span>
          </label>
          {{form.packageNumber == 1 ? '单项' : (form.packageNumber > 1 ? '多项' : '')}}
        </el-col>
        <el-col :span="10">
          <label>
            <span>售卖编号</span>
          </label>
          {{form.serviceRevise.selfId}}
        </el-col>

        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>体验券名称</span>
          </label>
          {{form.serviceName}}
        </el-col>
        <el-col :span="10">
          <label>
            <span>商品简介</span>
          </label>
          {{form.serviceContent}}
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>商品排序</span>
          </label>
          {{form.sorting}}
        </el-col>
        <el-col :span="10">
          <label>
            <span>可选几项</span>
          </label>
          {{form.packageNumberSelect}}
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>推荐位</span>
          </label>
          {{form.isSelling == 1 ? '店长推荐' : '无'}}
        </el-col>
        <el-col :span="10">
          <label>
            <span>售价</span>
          </label>
          <span class="point">{{form.price ? '¥'+Number(form.price).toFixed(2) :''}}</span>
        </el-col>

        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>有效期</span>
          </label>
          {{form.termFlag == 1 ? (form.validityStart +'-'+ form.validityEnd) : '不限'}}
        </el-col>

        <el-col :span="10">
          <label>
            <span>每项服务次数</span>
          </label>
          {{form.courseFrequency}}
        </el-col>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>售卖渠道</span>
          </label>
          {{form.serviceRevise.saleChannel | filterSaleChannel}}
        </el-col>
        <el-col :span="10" style="position:relative">
          <label>
            <span>备注</span>
          </label>
          <div class="myTxt" v-html="form.remarks"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="20">
          <div class="topTab">关联{{$store.state.userInfo.brandId == 1 ? '套盒' : '药贴'}}</div>
          <el-table
            :data="form.serviceSub"
            border
            class="myRelayionTable"
            :cell-style="{height:'42px'}"
            style="width: 100%"
            :header-cell-style="{background:'#EFF1F5',height:'47px'}"
          >
            <el-table-column align="center" prop="serviceName" label="商品名称">
              <template slot-scope="scope">
                <el-row class="tableGoods">
                  <el-popover trigger="hover" placement="top">
                    {{scope.row.serviceName}}
                    <el-col slot="reference" class="myTitle">
                      <span>{{scope.row.serviceName}}</span>
                    </el-col>
                  </el-popover>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="price" label="建议零售价">
              <template slot-scope="scope">{{Number(scope.row.price).toFixed(2)}}</template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="floorPrice" label="单次最低售价">
              <template slot-scope="scope">{{Number(scope.row.floorPrice).toFixed(2)}}</template>
            </el-table-column> -->
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>商品展示图</span>
          </label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="20">
          <el-upload
            class="upload-view"
            :auto-upload="false"
            action
            list-type="picture-card"
            :file-list="fileListData"
            :on-preview="handlePictureCardPreview"
            :disabled="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt>
          </el-dialog>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="10">
          <label>
            <span>图文说明</span>
          </label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="20">
          <div class="introductionCom" id="introImg" v-html="form.graphic"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="20">
          <div class="btnOptions">
            <el-button class="darkBtn" @click="closeTab">关闭</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script type="text/javascript">
import { ServiceInfos } from "@/api";
import { formatDate } from "@/components/common/js/date.js";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      form: {
        serviceRevise:{}
      },
      dialogVisible: false,
      dialogImageUrl: "",
      fileListData: [],
      fileLength: 0
    };
  },
  computed: {
    options() {
      return this.$store.state.options;
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(val) {
        this.$store.commit("set_active_index", val);
      }
    }
  },
  created() {
    this.detailInfo();
  },
  watch: {
    '$route.params.id'(val){
      if(val){
        this.detailInfo();
      }
    }
  },
  methods: {
    detailInfo() {
      ServiceInfos({
        serviceId: this.$route.params.id
      }).then(res => {
        if (res.code == 1) {
          this.form = res.data;
          this.form.validityStart = formatDate(
            this.form.validityStart,
            "yyyy/MM/dd"
          );
          this.form.validityEnd = formatDate(
            this.form.validityEnd,
            "yyyy/MM/dd"
          );
          let fileImgs = [];
          for (let i of res.data.files) {
            fileImgs.push({
              id: i.id,
              url: i.file,
              name: i.fileName
            });
          }
          this.fileListData = fileImgs;
          this.fileLength = parseInt(this.fileListData.length);

          this.form.serviceRevise = res.data.serviceRevise;
          this.form.remarks = this.form.remarks.replace(/\n/g,'<br />')
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    closeTab() {
      // 关闭当前tab
      this.$store.commit("delete_tabs", this.$route.path);
      this.$store.commit("setAliveStatus", true);//保留列表页状态
      this.$router.push("/businessManagementCenter/voucher");
      // 设置当前激活的路由
      // if (this.options && this.options.length >= 1) {
      //   this.$store.commit(
      //     "set_active_index",
      //     this.options[this.options.length - 1].route
      //   );
      //   this.$router.push({ path: this.activeIndex });
      // }
    }
  },
  updated() {
    if(document.getElementById("introImg")){
      let imgs = document.getElementById("introImg").getElementsByTagName("img");
      for (let i of imgs) {
        i.onclick = function() {
          let bigImg = document.createElement("img");
          if (!document.getElementById("myImgs")) {
            let op = document.createElement("div");
            let backs = document.createElement("div");
            document.body.appendChild(op);
            document.body.appendChild(backs);
            op.id = "myImgs";
            backs.id = "myBack";
            let mydiv = document.getElementById("myImgs");
            mydiv.appendChild(bigImg);
          } else {
            document.getElementById("myImgs").style.visibility = "visible";
            document.getElementById("myBack").style.visibility = "visible";
            document.getElementById("myImgs").appendChild(bigImg);
          }
          bigImg.src = i.src;
          document.getElementById("myBack").onclick = function() {
            document.getElementById("myImgs").style.visibility = "hidden";
            document.getElementById("myBack").style.visibility = "hidden";
            let div = document.getElementById("myImgs");
            div.removeChild(div.firstChild);
          };
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.voucherDetails {
  width: 950px;
  overflow: hidden;
  margin: 0 auto;
  padding: 80px 0 60px;
  position: relative;
  .voucherTit {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .el-row {
    margin-bottom: 15px;
    .point {
      color: #f83b56;
      font-size: 17px;
      font-weight: bold;
    }
    .myTxt {
      padding-left: 105px;
      margin-top: -30px;
    }
  }
  label {
    width: auto;
    text-align: right;
    display: inline-block;
    margin-right: 10px;
    span {
      min-width: 95px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      padding: 0 15px;
      background: #eff1f5;
      border-radius: 15px;
      color: #444;
    }
  }
  .upload-view {
    display: inline-block;
  }
  .topTab {
    width: 135px;
    height: 38px;
    line-height: 38px;
    background: #3b404f;
    border-radius: 15px 15px 0px 0px;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin-top: 25px;
  }
  .seize {
    height: 20px;
  }
  /* 图文介绍 */
  .introductionCom {
    border: 1px solid #dee6ea;
    padding: 28px 28px 50px 40px;
  }
}
</style>
<style lang="less">
.voucherDetails {
  .el-table td,
  .el-table th {
    padding: 0;
  }
  /* 图片列表禁止上传 */
  .upload-view .el-upload.el-upload--picture-card {
    display: none;
  }
  .upload-view
    .el-upload-list__item.is-success
    .el-upload-list__item-status-label,
  .upload-view .el-icon-upload-success.el-icon-check {
    opacity: 0;
    display: none;
  }
  .upload-view .el-upload-list--picture-card .el-upload-list__item {
    border: none;
  }
  .introductionCom img {
    max-width: 100%;
    h4 {
      border-bottom: 1px dashed #cdcdd7;
      font-weight: bold;
      img {
        margin-right: 10px;
      }
    }
    &.active:before {
      background: #000;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
    }
  }
  .btnOptions {
    text-align: center;
    margin:0;
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
  .tableGoods {
    &.el-row {
      margin-bottom: 0;
    }
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-table__header{
    background:rgb(239, 241, 245);
  }
}
/* 富文本框图片放大 */
  #myBack{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: .5;
    z-index: 9;
  }
  #myImgs{
      position: fixed;
      z-index: 999;
      width: 60%;
      max-height: 88%;
      overflow: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      background: #fff;
      text-align: center;
      padding: 20px 0;
  }
  #myImgs img{
    max-width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/voucherDetail.vue